import { validateForm } from '../form-designer/actions/runtime.actions';
import {
  ACTIONS_TRIGGER_VALIDATION,
  RUNTIME_FORMS,
} from '../form-designer/constants/runtime.constants';

export const VALIDATION_DELAY = process.env.NODE_ENV === 'test' ? 0 : 500;

let timer = undefined;

export const formValidator = ({ dispatch }) => (next) => (action) => {
  const { type, formKey } = action;

  next(action);

  if (ACTIONS_TRIGGER_VALIDATION.includes(type) && RUNTIME_FORMS.includes(formKey)) {
    clearTimeout(timer);

    timer = setTimeout(() => {
      dispatch(validateForm(formKey));
    }, VALIDATION_DELAY);
  }
};
